export default __webpack_public_path__ + "locales/en/DeleteThirdPartyDialog.json?hash=e65f4fa9e915fde3d83b3946d30eddd1";